import MUIPopover from '@mui/material/Popover';
import React from 'react';
export function Popover(props) {
    return (React.createElement(MUIPopover, Object.assign({ anchorOrigin: { horizontal: 'left', vertical: 'bottom' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, props)));
}
